const { isEmpty } = _uo.utility;

/**
 * Converts a date into an integer to sort actions
 * If this gets more complex in the future, use momentjs.
 * At the moment this is pretty easy and straightforward, so it doesn't make sense to add another dependency just to perform this task.
 * 
 * @param {String} date The date, in Y-m-d
 * @param {String} time The time, in h:i A
 * 
 * @return {Integer} The date represented by a number
 */
const convertDateToSortableInteger = ( date, time ) => {
    // Check if the date and time are defined
    if ( isEmpty( date) || isEmpty( time ) ) {
        return;
    } 

    // Remove the dashes from the date
    const dateAsNumber = parseInt( date.replaceAll( '-', '' ) );

    // Remove the AM/PM from the time
    const timeJustNumbers = parseInt( time.replace( /\D/g, '' ) ); 
    const timeAsNumber = time.includes( 'PM' ) ? timeJustNumbers + 1200 : timeJustNumbers;

    // Check if both the date and time are numbers
    if ( isNaN( dateAsNumber ) || isNaN( timeAsNumber ) ) {
        return;
    }

    return ( dateAsNumber + timeAsNumber );
} 

export default convertDateToSortableInteger;
